import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { ElementConditionLogicEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ElementConditionLogicSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    ElementConditionLogicCreated$() {
        return this.socketService.receiveMessageObserver(ElementConditionLogicEvents.ELEMENT_CONDITION_LOGIC_CREATED);
    }

    ElementConditionLogicUpdated$() {
        return this.socketService.receiveMessageObserver(ElementConditionLogicEvents.ELEMENT_CONDITION_LOGIC_UPDATED);
    }

    ElementConditionLogicDeleted$() {
        return this.socketService.receiveMessageObserver(ElementConditionLogicEvents.ELEMENT_CONDITION_LOGIC_DELETED);
    }
}
